import {
  KlarnaKosmaFlow,
  KlarnaKosmaFlowStatus,
} from '~/hooks/useKlarnaFlow/types';
import {
  KlarnaKosmaAction,
  UPDATE_TRANSACTION_FLOW,
} from '../types/klarnaKosmaTypes';

interface KlarnaKosmaState {
  readonly transactionFlow: KlarnaKosmaFlow;
}

const klarnaKosmaInitialState: KlarnaKosmaState = Object.freeze({
  transactionFlow: {
    status: 'idle' as KlarnaKosmaFlowStatus,
    error: '',
  },
});

const klarnaKosmaReducer = (
  state = klarnaKosmaInitialState,
  action: KlarnaKosmaAction
): KlarnaKosmaState => {
  switch (action.type) {
    case UPDATE_TRANSACTION_FLOW:
      return {
        ...state,
        transactionFlow: {
          ...state.transactionFlow,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default klarnaKosmaReducer;
